<script lang="ts">
	import { Icon, IconButton, systemInformationStore } from '@enzianweb/shared';
	import { _ } from 'svelte-i18n';

	let hideInfoBanner: boolean = false;
</script>

{#if $systemInformationStore?.isShowIncident && !hideInfoBanner}
	<div class="bg-secondary-200 flex items-center col-span-3 fill-yellow gap-2">
		<div class="grow"></div>
		<Icon name="triangle-exclamation"></Icon>
		<p class="text-white">{$_('incident.lbl_info')}</p>
		<a href={import.meta.env.VITE_INCIDENT_URL} target="_blank" class="text-secondary-300"
			>{$_('incident.lbl_link')}</a
		>
		<div class="grow"></div>
		<IconButton
			showCircle={false}
			iconName="xmark"
			onClick={() => {
				hideInfoBanner = true;
			}}
		></IconButton>
	</div>
{/if}
